export default __webpack_public_path__ + "static/media/building-9.0eaed252.png";